import React from 'react';
import './Icon.css';

export default (props) => {
  return (
    <svg
      className="Icon Icon-Tux"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      style={{"enableBackground":"new 0 0 100 100"}}
      xmlSpace="preserve"
      {...props}
    >
      <title>{props.title || "Tux"}</title>
      <g>
        <path d="M50.3,30c1.735,0,3.263-0.885,4.159-2.228L65.3,35V15l-10.841,7.228C53.562,20.885,52.035,20,50.3,20   s-3.262,0.885-4.159,2.228L35.3,15v20l10.841-7.228C47.038,29.115,48.564,30,50.3,30z"/>
        <polygon points="70.3,30 50.3,85 80.3,45  "/>
        <polygon points="20.3,45 50.3,85 30.3,30  "/>
        <circle cx="50.3" cy="42.5" r="2.5"/>
        <circle cx="50.3" cy="52.5" r="2.5"/>
        <circle cx="50.3" cy="62.5" r="2.5"/>
      </g>
    </svg>
  )
};



// WEBPACK FOOTER //
// ./src/component/atoms/Icon/Tux.js